import React from 'react'
import styles from './Loader.module.scss'
import cx from 'classnames'

type LoaderProps = {
    isLoading: boolean
    classes?: string
    color?: string
    size?: 's' | 'm' | 'l'
}

const Loader: React.FC<LoaderProps> = ({ isLoading, classes, size = 's' }) => {
    return isLoading ? (
        <div
            className={cx(
                styles['zr-loader'],
                size === 's' ? styles['zr-loader-s'] : '',
                size === 'm' ? styles['zr-loader-m'] : '',
                size === 'l' ? styles['zr-loader-l'] : '',
                classes
            )}
        />
    ) : null
}

export default Loader
